export default __webpack_public_path__ + "static/media/3793099.0cf6a016.jpg";